import { Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ClxFormComponent } from '@forms';
import { __i18n } from '@localisation';
import { PlantService } from '@plants';
import { MessagesComponent, MessagesService, MessageType } from '@ui-messages';
import { UserService } from '@user';
import { UpgradeConfigurationComponent } from '../upgrade-configuration.component';
import { UpgradeService } from '../upgrade.service';
import { BatchUpgradeService } from './batch-upgrade.service';

@Component({
    selector: 'batch-upgrade-configuration',
    templateUrl: './batch-upgrade-configuration.template.html',
    standalone: false
})
export class BatchUpgradeConfigurationComponent extends UpgradeConfigurationComponent{
    constructor(
        public user: UserService,
        public upgradeService: UpgradeService,
        public messageService: MessagesService,
        public plantService: PlantService,
        private batchUpgradeService: BatchUpgradeService,
        private router: Router
    ){
        super(user, upgradeService, messageService, plantService);
    }

    public start: number = Date.now();

    public end: number = Date.now();

    @Input()
    public set resource(resource: any){
        this.innerResource = resource;
    }

    public get resource(){
        return this.innerResource;
    }

    @Input()
    public selectedPlants: any = [];

    @ViewChild(ClxFormComponent)
    public upgradeForm: ClxFormComponent;

    @ViewChild('messageBox')
    public messageBox: MessagesComponent

    public async send(data){
        if(this.upgradeForm.validate()){
            data.plantIds = this.selectedPlants;
            data.startDate = new Date(data.startTime);
            data.endDate = new Date(data.endTime);
            data.userTimezoneOffsetStart = -data.startDate.getTimezoneOffset();
            data.userTimezoneOffsetEnd = -data.endDate.getTimezoneOffset();
            await this.batchUpgradeService.scheduleBatchUpgrade(data);
            const url = '/Administration/Upgrade';
            this.messageService.addMessage({
                text: __i18n('Batch upgrade successfully scheduled', 'operating.plants.batch-upgrade.success.message'),
                type: MessageType.success
            })


            this.router.navigateByUrl(url);

            this.isVisible = false;
        }
    }


    public open(){
        this.messageBox.messages = [];
        this.isVisible = true;
        this.now = Date.now();
        this.start = Date.now() + 60000;
        this.end = Date.now() + 240000;
    }


    public showMappingFile: boolean = true;

}